{
  "title": "Gestion des Abonnements",
  "description": "Créer et gérer les abonnements des praticiens",
  "practitioners": {
    "title": "Praticiens Indépendants",
    "createSubscription": "Créer un Abonnement",
    "noPractitioners": "Aucun praticien indépendant trouvé",
    "noProfile": "Aucun profil",
    "extend": "Prolonger",
    "create": "Créer",
    "table": {
      "name": "Nom",
      "email": "Email",
      "subscription": "Abonnement",
      "endDate": "Date de Fin",
      "actions": "Actions"
    }
  },
  "status": {
    "noSubscription": "Aucun Abonnement",
    "active": "Actif",
    "trial": "Essai",
    "expired": "Expiré"
  },
  "create": {
    "title": "Créer un Abonnement Praticien",
    "description": "Créer un abonnement pour un praticien indépendant",
    "practitioner": "Praticien",
    "selectPractitioner": "Sélectionner un praticien",
    "subscriptionType": "Type d'Abonnement",
    "trialType": "Essai Pro (15 jours)",
    "proType": "Pro (Accès complet)",
    "startDate": "Date de Début",
    "endDate": "Date de Fin",
    "selectDate": "Sélectionner une date",
    "existingSubscription": "Ce praticien a déjà un abonnement {{type}} se terminant le {{endDate}}. Créer un nouvel abonnement remplacera l'existant.",
    "cancel": "Annuler",
    "confirm": "Créer l'Abonnement"
  },
  "update": {
    "title": "Mettre à Jour l'Abonnement",
    "description": "Prolonger l'abonnement pour {{name}}",
    "currentType": "Type Actuel",
    "currentEndDate": "Date de Fin Actuelle",
    "newEndDate": "Nouvelle Date de Fin",
    "selectDate": "Sélectionner une date",
    "cancel": "Annuler",
    "confirm": "Mettre à Jour l'Abonnement"
  },
  "errors": {
    "createSubscriptionFailed": "Échec de la création de l'abonnement",
    "updateSubscriptionFailed": "Échec de la mise à jour de l'abonnement"
  },
  "success": {
    "createSubscriptionSuccess": "Abonnement créé avec succès",
    "updateSubscriptionSuccess": "Abonnement mis à jour avec succès"
  },
  "liberal": {
    "pageTitle": "Mon abonnement",
    "pageSubtitle": "Gérez votre abonnement Pro libéral",
    "trialActive": "Votre essai gratuit se termine le {{date}}. Abonnez-vous dès maintenant pour conserver un accès complet.",
    "trialExpired": "Votre essai gratuit est terminé. Abonnez-vous pour retrouver l'accès complet à la plateforme.",
    "monthly": {
      "title": "Mensuel",
      "price": "29,99€",
      "period": "/mois",
      "description": "Accès complet, sans engagement",
      "cta": "S'abonner au mensuel"
    },
    "annual": {
      "title": "Annuel",
      "price": "299,99€",
      "period": "/an",
      "savings": "2 mois offerts",
      "description": "Soit environ 24,99€/mois",
      "cta": "S'abonner à l'annuel"
    },
    "active": {
      "title": "Abonnement actif",
      "nextBilling": "Prochaine échéance",
      "manageButton": "Gérer la facturation",
      "cancelButton": "Résilier l'abonnement"
    },
    "canceled": {
      "title": "Résiliation programmée",
      "description": "Votre abonnement sera résilié le {{date}}. Vous conservez l'accès jusqu'à cette date."
    },
    "cancelDialog": {
      "title": "Résilier votre abonnement ?",
      "description": "Votre abonnement restera actif jusqu'à la fin de la période facturée. Aucun remboursement ne sera effectué.",
      "confirm": "Oui, résilier",
      "cancel": "Non, conserver"
    },
    "errors": {
      "checkoutFailed": "Impossible de créer la session de paiement",
      "portalFailed": "Impossible d'ouvrir le portail de facturation",
      "cancelFailed": "Impossible de résilier l'abonnement",
      "fetchFailed": "Impossible de récupérer votre abonnement"
    },
    "success": {
      "checkoutTitle": "Paiement confirmé",
      "checkoutDescription": "Votre abonnement Pro est maintenant actif. Bienvenue !",
      "backToBilling": "Retour à mon abonnement",
      "cancelSuccess": "Votre abonnement sera résilié à la fin de la période en cours"
    }
  }
}
